module.exports = __webpack_public_path__ + "img/Fototalleres.83883048.png";